import { Typography, Box, Button, Alert, Grid2 as Grid } from '@mui/material';
import { FC } from 'react';
import { Add, Delete } from '@mui/icons-material';

import { JobseekerCreateDto } from '@libs/dto';
import { useForm } from '@carcareers/contexts';
import { TextInput, DateInput } from '@carcareers/components';

export const CertificatesStep: FC = () => {
  const { data, setData } = useForm<JobseekerCreateDto>();
  const certificates = data?.certificates || [];

  const addCertificate = () => {
    const newCertificate = {
      name: '',
      issuingAuthority: '',
      issueDate: '',
      description: '',
    };
    setData('certificates', [...certificates, newCertificate]);
  };

  const removeCertificate = (index: number) => {
    const updatedCertificates = certificates.filter((_, i) => i !== index);
    setData('certificates', updatedCertificates);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Typography variant="h5" component="h2" sx={{ mb: 2, fontWeight: 600 }}>
        Certificates
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6">Certificates & Licenses</Typography>
        <Button startIcon={<Add />} onClick={addCertificate}>
          Add Certificate
        </Button>
      </Box>

      {certificates.map((_, index) => (
        <Box key={index} sx={{ border: 1, borderColor: 'divider', borderRadius: 1, p: 3 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="subtitle1">Certificate #{index + 1}</Typography>
            <Button startIcon={<Delete />} color="error" onClick={() => removeCertificate(index)}>
              Remove
            </Button>
          </Box>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextInput label="Certificate Name" name={`certificates.${index}.name`} fullWidth required />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextInput label="Issuing Authority" name={`certificates.${index}.issuingAuthority`} fullWidth required />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <DateInput label="Issue Date" name={`certificates.${index}.issueDate`} />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextInput label="Description" name={`certificates.${index}.description`} multiline rows={3} fullWidth />
            </Grid>
          </Grid>
        </Box>
      ))}

      {certificates.length === 0 && (
        <Alert severity="info">Certificates and licenses are optional but can enhance your profile.</Alert>
      )}
    </Box>
  );
};

export default CertificatesStep;
